import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'dark' | 'ghost' | 'danger' | 'icon' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'icon';
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  ...props
}: ButtonProps) {
  const variants = {
    // 1. Primary — solid brand pink, refined and professional
    primary: 'jua-btn-primary bg-[#EC4899] !text-white font-semibold rounded-lg shadow-[0_1px_2px_rgba(0,0,0,0.08),0_2px_8px_rgba(236,72,153,0.25)] hover:bg-[#db2777] hover:shadow-[0_2px_4px_rgba(0,0,0,0.1),0_4px_12px_rgba(236,72,153,0.3)] active:bg-[#be185d] active:shadow-[0_1px_2px_rgba(0,0,0,0.1)] transition-all duration-150',
    // 2. Secondary — glassy frosted style
    secondary: 'jua-btn-secondary bg-white/60 backdrop-blur-xl border border-white/40 text-slate-700 font-semibold rounded-xl shadow-[0_2px_12px_rgba(148,163,184,0.10),inset_0_1px_0_rgba(255,255,255,0.25)] hover:bg-white/80 hover:border-white/55 hover:shadow-[0_4px_16px_rgba(148,163,184,0.15),inset_0_1px_0_rgba(255,255,255,0.35)] transition-all',
    // 3. Dark — slate 900 (modal confirmations, create actions)
    dark: 'bg-slate-900 text-white font-semibold rounded-xl hover:bg-slate-800 transition-all',
    // 4. Ghost — text only
    ghost: 'bg-transparent text-slate-600 font-medium hover:text-slate-900 transition-colors rounded-lg',
    // 5. Destructive ghost
    danger: 'bg-transparent text-red-600 font-medium hover:text-red-700 hover:bg-red-50 rounded-lg transition-all',
    // 6. Icon / toolbar
    icon: 'p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100/60 transition-colors',
    // 7. Outline — light-mode glassy with white border and transparent blur
    outline: 'bg-white/40 backdrop-blur-xl border border-white/40 text-slate-700 font-semibold rounded-xl shadow-[0_2px_12px_rgba(148,163,184,0.08),inset_0_1px_0_rgba(255,255,255,0.25)] hover:bg-white/60 hover:border-white/55 hover:shadow-[0_4px_16px_rgba(148,163,184,0.12),inset_0_1px_0_rgba(255,255,255,0.35)] transition-all'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-9 px-4 text-sm',
    lg: 'h-11 px-6 text-base',
    icon: 'h-9 w-9 p-2 flex items-center justify-center'
  };
  return <button className={cn('inline-flex items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pink-500 disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed', variants[variant], variant !== 'icon' && sizes[size], className)} {...props} data-id="element-1121" />;
}